import { SkillCategory } from '../types';

export const skills: SkillCategory = {
    frontend: [
        { name: 'React', level: 95 },
        { name: 'TypeScript', level: 90 },
        { name: 'JavaScript', level: 95 },
        { name: 'Tailwind CSS', level: 90 },
        { name: 'HTML5', level: 95 },
        { name: 'CSS3', level: 90 },
    ],
    backend: [
        { name: 'Node.js', level: 95 },
        { name: 'Java', level: 85 },
        { name: 'Spring Boot', level: 85 },
        { name: 'MySQL', level: 85 },
        { name: 'MongoDB', level: 80 },
        { name: 'GraphDB', level: 85 },
        { name: 'Redis', level: 85 }
    ],
    tools: [
        { name: 'AWS', level: 90 },
        { name: 'Git', level: 95 },
        { name: 'Docker', level: 80 },
        { name: 'Jenkins', level: 85 },
        { name: 'Serverless Framework', level: 90 },
    ]
}; 